import React from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {useLocation, useNavigate} from 'react-router-dom';
import dayjs from 'dayjs';
import {PinkButton} from '../../components/button';
import {TextG16, TextG24} from '../../components/typography';

const SuccessCheckCircle = () => (
  <svg width={132} height={132} viewBox="0 0 132 132" fill="none">
    <circle cx="66" cy="66" r="66" fill="#CFEEC0" />
    <path
      d="M40 68l18 18 36-40"
      stroke="#197A2A"
      strokeWidth={7}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

type LocationState = {
  paidThroughDate?: string;
} | null;

const formatDate = (raw?: string) => (raw ? dayjs(raw).format('MMMM D, YYYY') : '');

const MembershipPauseSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state as LocationState) || {};
  const accessUntil = formatDate(state.paidThroughDate);

  return (
    <Flex direction="column" minH="100vh" bg="white" position="relative">
      <Box h="88px" />
      <Flex flex={1} direction="column" align="center" textAlign="center" px={8} gap={6}>
        <SuccessCheckCircle />
        <Box
          fontFamily="Manrope, ui-sans-serif, system-ui, sans-serif"
          fontWeight={700}
          lineHeight="30px"
          color="#262626">
          <TextG24 fontSize="26px" lineHeight="34px">
            We&rsquo;ll miss you&hellip;
          </TextG24>
        </Box>
        <TextG16 color="#4D4D4D" lineHeight="24px" maxW="340px">
          {accessUntil ? (
            <>
              You&rsquo;ll keep full access to your benefits until{' '}
              <strong style={{color: '#262626'}}>{accessUntil}.</strong>
            </>
          ) : (
            <>You&rsquo;ll keep full access to your benefits until your current period ends.</>
          )}
          <br />
          <br />
          You can always renew your membership to access hundreds of dollars in value right around
          the corner and join others in enjoying your neighborhood like never before.
          <br />
          <br />
          Hope you come back soon!
        </TextG16>
      </Flex>
      <Box
        position="sticky"
        bottom={0}
        bg="white"
        px={5}
        pt={3}
        pb={9}
        display="flex"
        flexDirection="column"
        gap={3}
        alignItems="center">
        <PinkButton
          h="52px"
          borderRadius="100px"
          width="100%"
          onClick={() => navigate('/home', {replace: true})}>
          Done
        </PinkButton>
      </Box>
    </Flex>
  );
};

export default MembershipPauseSuccess;
